import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_appplugin_7beb8701 from 'nuxt_plugin_appplugin_7beb8701'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_1dbcacee from 'nuxt_plugin_configplugin_1dbcacee'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_templatesplugind8fe56d0_c43df03e from 'nuxt_plugin_templatesplugind8fe56d0_c43df03e'; // Source: ./templates.plugin.d8fe56d0.js (mode: 'client')
import nuxt_plugin_nuxtleaflet_4a5e0d54 from 'nuxt_plugin_nuxtleaflet_4a5e0d54'; // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_tooltipplugin20b62423_644303bc from 'nuxt_plugin_tooltipplugin20b62423_644303bc'; // Source: ./tooltip.plugin.20b62423.js (mode: 'all')
import nuxt_plugin_buttonplugin361506c8_0fe77d26 from 'nuxt_plugin_buttonplugin361506c8_0fe77d26'; // Source: ./button.plugin.361506c8.js (mode: 'all')
import nuxt_plugin_textareaplugin701aa164_0beff02e from 'nuxt_plugin_textareaplugin701aa164_0beff02e'; // Source: ./textarea.plugin.701aa164.js (mode: 'all')
import nuxt_plugin_inputtextplugin6f231752_21dd272f from 'nuxt_plugin_inputtextplugin6f231752_21dd272f'; // Source: ./inputtext.plugin.6f231752.js (mode: 'all')
import nuxt_plugin_multiselectplugin4c980b95_6e732609 from 'nuxt_plugin_multiselectplugin4c980b95_6e732609'; // Source: ./multiselect.plugin.4c980b95.js (mode: 'all')
import nuxt_plugin_configplugin149b04ac_7d087374 from 'nuxt_plugin_configplugin149b04ac_7d087374'; // Source: ./config.plugin.149b04ac.js (mode: 'all')
import nuxt_plugin_pluginutils_f63077ec from 'nuxt_plugin_pluginutils_f63077ec'; // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_bff11256 from 'nuxt_plugin_pluginrouting_bff11256'; // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6e37ecba from 'nuxt_plugin_pluginmain_6e37ecba'; // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_3f1c135e from 'nuxt_plugin_axios_3f1c135e'; // Source: ./axios.js (mode: 'all')
import nuxt_plugin_capiplugin_7ce9e3bc from 'nuxt_plugin_capiplugin_7ce9e3bc'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_58a748c7 from 'nuxt_plugin_errorpluginserver_58a748c7'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_templatesplugin02aad04a_6b5a42b4 from 'nuxt_plugin_templatesplugin02aad04a_6b5a42b4'; // Source: ./templates.plugin.02aad04a.js (mode: 'client')
import nuxt_plugin_nuxtuseragent_5e4e6fda from 'nuxt_plugin_nuxtuseragent_5e4e6fda'; // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_pinia_4c9a7fd4 from 'nuxt_plugin_pinia_4c9a7fd4'; // Source: ../plugins/pinia.ts (mode: 'all')
import nuxt_plugin_whitelabel_9132a414 from 'nuxt_plugin_whitelabel_9132a414'; // Source: ../plugins/whitelabel.js (mode: 'all')
import nuxt_plugin_validation_7d99b1b0 from 'nuxt_plugin_validation_7d99b1b0'; // Source: ../plugins/validation.js (mode: 'all')
import nuxt_plugin_debounce_06d08b0e from 'nuxt_plugin_debounce_06d08b0e'; // Source: ../plugins/debounce.ts (mode: 'all')
import nuxt_plugin_sanitizer_b82b1ab8 from 'nuxt_plugin_sanitizer_b82b1ab8'; // Source: ../plugins/sanitizer.js (mode: 'all')
import nuxt_plugin_jsonld_2ff76817 from 'nuxt_plugin_jsonld_2ff76817'; // Source: ../plugins/jsonld.ts (mode: 'all')
import nuxt_plugin_notifier_3e43155b from 'nuxt_plugin_notifier_3e43155b'; // Source: ../plugins/notifier.js (mode: 'all')
import nuxt_plugin_clickOutside_0ea087a4 from 'nuxt_plugin_clickOutside_0ea087a4'; // Source: ../plugins/clickOutside.js (mode: 'all')
import nuxt_plugin_tooltip_a5fff1ec from 'nuxt_plugin_tooltip_a5fff1ec'; // Source: ../plugins/tooltip.js (mode: 'all')
import nuxt_plugin_vstripe_4841e0bd from 'nuxt_plugin_vstripe_4841e0bd'; // Source: ../plugins/v-stripe.js (mode: 'client')
import nuxt_plugin_authPersistence_15fe8dec from 'nuxt_plugin_authPersistence_15fe8dec'; // Source: ../plugins/authPersistence.ts (mode: 'client')
import nuxt_plugin_cropper_050a3380 from 'nuxt_plugin_cropper_050a3380'; // Source: ../plugins/cropper.js (mode: 'client')
import nuxt_plugin_iframeResizercontentWindow_4c7bfeac from 'nuxt_plugin_iframeResizercontentWindow_4c7bfeac'; // Source: ../node_modules/iframe-resizer/js/iframeResizer.contentWindow.js (mode: 'client')
import nuxt_plugin_nozoom_079c012e from 'nuxt_plugin_nozoom_079c012e'; // Source: ../plugins/no-zoom.js (mode: 'client')
import nuxt_plugin_matomo_ad92b6a0 from 'nuxt_plugin_matomo_ad92b6a0'; // Source: ../plugins/matomo.js (mode: 'client')
import nuxt_plugin_clarity_3440f159 from 'nuxt_plugin_clarity_3440f159'; // Source: ../plugins/clarity.js (mode: 'client')
import nuxt_plugin_sportradar_1ba2ae22 from 'nuxt_plugin_sportradar_1ba2ae22'; // Source: ../plugins/sportradar.js (mode: 'client')
import nuxt_plugin_cookieConsent_826316d2 from 'nuxt_plugin_cookieConsent_826316d2'; // Source: ../plugins/cookieConsent.js (mode: 'client')
import nuxt_plugin_vuetour_f3e3d3bc from 'nuxt_plugin_vuetour_f3e3d3bc'; // Source: ../plugins/vue-tour.js (mode: 'client')
import nuxt_plugin_featurebase_f807a274 from 'nuxt_plugin_featurebase_f807a274'; // Source: ../plugins/featurebase.js (mode: 'client')
import nuxt_plugin_auth_9fbdb682 from 'nuxt_plugin_auth_9fbdb682'; // Source: ./auth.js (mode: 'all')
import nuxt_plugin_axios_5659cf26 from 'nuxt_plugin_axios_5659cf26'; // Source: ../plugins/axios.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = createStore(ssrContext);
          _context2.next = 1;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 1:
          router = _context2.sent;
          // Add this.$router into store actions/mutations
          store.$router = router;

          // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
          store.registerModule = registerModule;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "titleTemplate": "%s",
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1"
              }],
              "script": [{
                "hid": "seatsio",
                "src": "https://cdn.seatsio.net/chart.js"
              }],
              "link": [{
                "rel": "icon",
                "type": "image/x-icon",
                "href": "/tickethead/favicon.svg"
              }],
              "style": [{
                "cssText": ".WEB_h72_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 72px;\nline-height: 86.39999999999999px;\nletter-spacing: -1.44px;\nfont-weight: 400;\n}\n.WEB_h72_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 72px;\nline-height: 86.39999999999999px;\nletter-spacing: -1.44px;\nfont-weight: 500;\n}\n.WEB_h72_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 72px;\nline-height: 86.39999999999999px;\nletter-spacing: -1.44px;\nfont-weight: 600;\n}\n.WEB_h72_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 72px;\nline-height: 86.39999999999999px;\nletter-spacing: -1.44px;\nfont-weight: 700;\n}\n.WEB_h60_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 60px;\nline-height: 66px;\nletter-spacing: -0.6px;\nfont-weight: 400;\n}\n.WEB_h60_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 60px;\nline-height: 66px;\nletter-spacing: -0.6px;\nfont-weight: 500;\n}\n.WEB_h60_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 60px;\nline-height: 66px;\nletter-spacing: -0.6px;\nfont-weight: 600;\n}\n.WEB_h60_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 60px;\nline-height: 66px;\nletter-spacing: -0.6px;\nfont-weight: 700;\n}\n.WEB_h48_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 48px;\nline-height: 57.599999999999994px;\nletter-spacing: -0.96px;\nfont-weight: 400;\n}\n.WEB_h48_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 48px;\nline-height: 57.599999999999994px;\nletter-spacing: -0.96px;\nfont-weight: 500;\n}\n.WEB_h48_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 48px;\nline-height: 57.599999999999994px;\nletter-spacing: -0.96px;\nfont-weight: 600;\n}\n.WEB_h48_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 48px;\nline-height: 57.599999999999994px;\nletter-spacing: -0.96px;\nfont-weight: 700;\n}\n.WEB_h39_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 39px;\nline-height: 42.900000000000006px;\nletter-spacing: -0.39px;\nfont-weight: 400;\n}\n.WEB_h39_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 39px;\nline-height: 42.900000000000006px;\nletter-spacing: -0.39px;\nfont-weight: 500;\n}\n.WEB_h39_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 39px;\nline-height: 42.900000000000006px;\nletter-spacing: -0.39px;\nfont-weight: 600;\n}\n.WEB_h39_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 39px;\nline-height: 42.900000000000006px;\nletter-spacing: -0.39px;\nfont-weight: 700;\n}\n.WEB_h36_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 36px;\nline-height: 39.6px;\nletter-spacing: -0.36px;\nfont-weight: 400;\n}\n.WEB_h36_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 36px;\nline-height: 39.6px;\nletter-spacing: -0.36px;\nfont-weight: 500;\n}\n.WEB_h36_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 36px;\nline-height: 39.6px;\nletter-spacing: -0.36px;\nfont-weight: 600;\n}\n.WEB_h36_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 36px;\nline-height: 39.6px;\nletter-spacing: -0.36px;\nfont-weight: 700;\n}\n.WEB_h32_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 32px;\nline-height: 35.2px;\nletter-spacing: 0px;\nfont-weight: 400;\n}\n.WEB_h32_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 32px;\nline-height: 35.2px;\nletter-spacing: 0px;\nfont-weight: 500;\n}\n.WEB_h32_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 32px;\nline-height: 35.2px;\nletter-spacing: 0px;\nfont-weight: 600;\n}\n.WEB_h32_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 32px;\nline-height: 35.2px;\nletter-spacing: 0px;\nfont-weight: 700;\n}\n.MOBILE_h24_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 24px;\nline-height: 28.799999999999997px;\nletter-spacing: -0.24px;\nfont-weight: 400;\n}\n.MOBILE_h24_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 24px;\nline-height: 28.799999999999997px;\nletter-spacing: -0.24px;\nfont-weight: 500;\n}\n.MOBILE_h24_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 24px;\nline-height: 28.799999999999997px;\nletter-spacing: -0.24px;\nfont-weight: 600;\n}\n.MOBILE_h24_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 24px;\nline-height: 28.799999999999997px;\nletter-spacing: -0.24px;\nfont-weight: 700;\n}\n.MOBILE_h22_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 22px;\nline-height: 24.200000000000003px;\nletter-spacing: -0.22px;\nfont-weight: 400;\n}\n.MOBILE_h22_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 22px;\nline-height: 24.200000000000003px;\nletter-spacing: -0.22px;\nfont-weight: 500;\n}\n.MOBILE_h22_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 22px;\nline-height: 24.200000000000003px;\nletter-spacing: -0.22px;\nfont-weight: 600;\n}\n.MOBILE_h22_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 22px;\nline-height: 24.200000000000003px;\nletter-spacing: -0.22px;\nfont-weight: 700;\n}\n.MOBILE_h20_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 20px;\nline-height: 26px;\nletter-spacing: 0.2px;\nfont-weight: 400;\n}\n.MOBILE_h20_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 20px;\nline-height: 26px;\nletter-spacing: 0.2px;\nfont-weight: 500;\n}\n.MOBILE_h20_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 20px;\nline-height: 26px;\nletter-spacing: 0.2px;\nfont-weight: 600;\n}\n.MOBILE_h20_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 20px;\nline-height: 26px;\nletter-spacing: 0.2px;\nfont-weight: 700;\n}\n.MOBILE_h18_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 18px;\nline-height: 21.599999999999998px;\nletter-spacing: 0px;\nfont-weight: 400;\n}\n.MOBILE_h18_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 18px;\nline-height: 21.599999999999998px;\nletter-spacing: 0px;\nfont-weight: 500;\n}\n.MOBILE_h18_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 18px;\nline-height: 21.599999999999998px;\nletter-spacing: 0px;\nfont-weight: 600;\n}\n.MOBILE_h18_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 18px;\nline-height: 21.599999999999998px;\nletter-spacing: 0px;\nfont-weight: 700;\n}\n.MOBILE_h16_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 16px;\nline-height: 20.8px;\nletter-spacing: 0.16px;\nfont-weight: 400;\n}\n.MOBILE_h16_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 16px;\nline-height: 20.8px;\nletter-spacing: 0.16px;\nfont-weight: 500;\n}\n.MOBILE_h16_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 16px;\nline-height: 20.8px;\nletter-spacing: 0.16px;\nfont-weight: 600;\n}\n.MOBILE_h16_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 16px;\nline-height: 20.8px;\nletter-spacing: 0.16px;\nfont-weight: 700;\n}\n.MOBILE_h14_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 14px;\nline-height: 18.2px;\nletter-spacing: 0.14px;\nfont-weight: 400;\n}\n.MOBILE_h14_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 14px;\nline-height: 18.2px;\nletter-spacing: 0.14px;\nfont-weight: 500;\n}\n.MOBILE_h14_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 14px;\nline-height: 18.2px;\nletter-spacing: 0.14px;\nfont-weight: 600;\n}\n.MOBILE_h14_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 14px;\nline-height: 18.2px;\nletter-spacing: 0.14px;\nfont-weight: 700;\n}\n.MOBILE_h13_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 13px;\nline-height: 16.900000000000002px;\nletter-spacing: 0.13px;\nfont-weight: 400;\n}\n.MOBILE_h13_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 13px;\nline-height: 16.900000000000002px;\nletter-spacing: 0.13px;\nfont-weight: 500;\n}\n.MOBILE_h13_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 13px;\nline-height: 16.900000000000002px;\nletter-spacing: 0.13px;\nfont-weight: 600;\n}\n.MOBILE_h13_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 13px;\nline-height: 16.900000000000002px;\nletter-spacing: 0.13px;\nfont-weight: 700;\n}\n.MOBILE_h12_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 12px;\nline-height: 15.600000000000001px;\nletter-spacing: 0.48px;\nfont-weight: 400;\n}\n.MOBILE_h12_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 12px;\nline-height: 15.600000000000001px;\nletter-spacing: 0.48px;\nfont-weight: 500;\n}\n.MOBILE_h12_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 12px;\nline-height: 15.600000000000001px;\nletter-spacing: 0.48px;\nfont-weight: 600;\n}\n.MOBILE_h12_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 12px;\nline-height: 15.600000000000001px;\nletter-spacing: 0.48px;\nfont-weight: 700;\n}\n.MOBILE_h11_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 11px;\nline-height: 14.3px;\nletter-spacing: 0.44px;\nfont-weight: 400;\n}\n.MOBILE_h11_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 11px;\nline-height: 14.3px;\nletter-spacing: 0.44px;\nfont-weight: 500;\n}\n.MOBILE_h11_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 11px;\nline-height: 14.3px;\nletter-spacing: 0.44px;\nfont-weight: 600;\n}\n.MOBILE_h11_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 11px;\nline-height: 14.3px;\nletter-spacing: 0.44px;\nfont-weight: 700;\n}\n.MOBILE_h8_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 8px;\nline-height: 10.4px;\nletter-spacing: 0.32px;\nfont-weight: 400;\n}\n.MOBILE_h8_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 8px;\nline-height: 10.4px;\nletter-spacing: 0.32px;\nfont-weight: 500;\n}\n.MOBILE_h8_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 8px;\nline-height: 10.4px;\nletter-spacing: 0.32px;\nfont-weight: 600;\n}\n.MOBILE_h8_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 8px;\nline-height: 10.4px;\nletter-spacing: 0.32px;\nfont-weight: 700;\n}\n",
                "type": "text/css"
              }, {
                "cssText": ":root {\n  --v-textPrimary-base: #010e21;\n  --v-textPrimary-lighten1: #343e4d;\n  --v-textPrimary-lighten2: #676e7a;\n  --v-textPrimary-lighten3: #999fa6;\n  --v-textPrimary-lighten4: #cccfd3;\n  --v-textPrimary-lighten5: #ffffff;\n  --v-textGray-base: #dfdfdf;\n  --v-textGray-lighten1: #ebebeb;\n  --v-textGray-lighten2: #f3f3f3;\n  --v-textHighlightError-base: #d9342b;\n  --v-textHighlightWarning-base: #f59e0b;\n  --v-textHighlightSuccess-base: #1ea97c;\n  --v-textHighlightInfo-base: #3b82f6;\n  --v-backgroundPrimary-base: #010e21;\n  --v-backgroundPrimary-lighten1: #343e4d;\n  --v-backgroundPrimary-lighten2: #676e7a;\n  --v-backgroundPrimary-lighten3: #999fa6;\n  --v-backgroundPrimary-lighten4: #cccfd3;\n  --v-backgroundPrimary-lighten5: #ffffff;\n  --v-backgroundGray-base: #d7d7d7;\n  --v-backgroundGray-lighten1: #dfdfdf;\n  --v-backgroundGray-lighten2: #ebebeb;\n  --v-backgroundGray-lighten3: #f3f3f3;\n  --v-backgroundOverlay-base: #ffffff;\n  --v-backgroundHighlightError-base: #d9342b;\n  --v-backgroundHighlightWarning-base: #f59e0b;\n  --v-backgroundHighlightWarning-lighten1: #facf85;\n  --v-backgroundHighlightSuccess-base: #1ea97c;\n  --v-backgroundHighlightSuccess-lighten1: #8fd4bd;\n  --v-backgroundHighlightTransparentError-base: #f7d6d5;\n  --v-borderPrimary-base: #010e21;\n  --v-borderPrimary-lighten1: #343e4d;\n  --v-borderPrimary-lighten2: #676e7a;\n  --v-borderPrimary-lighten3: #999fa6;\n  --v-borderPrimary-lighten4: #cccfd3;\n  --v-borderHighlightError-base: #d9342b;\n  --v-borderHighlightWarning-base: #f59e0b;\n  --v-borderHighlightSuccess-base: #1ea97c;\n  --v-borderHighlightInfo-base: #3b82f6;\n  --v-buttonPrimary-base: #010e21;\n  --v-buttonPrimary-lighten1: #343e4d;\n  --v-buttonPrimary-lighten2: #676e7a;\n  --v-buttonPrimary-lighten3: #999fa6;\n  --v-buttonPrimary-lighten4: #cccfd3;\n  --v-buttonGray-base: #dfdfdf;\n  --v-buttonGray-lighten1: #ebebeb;\n  --v-buttonHighlightError-base: #d9342b;\n  --v-buttonHighlightTransparentError-base: #f7d6d5;\n  --v-buttonHighlightErrorFilled-base: #c73d39;\n}\n",
                "type": "text/css"
              }],
              "bodyAttrs": {
                "class": ["p-input-filled"]
              }
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              errPageReady: false,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                nuxt.errPageReady = false;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 2;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 2:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(typeof nuxt_plugin_appplugin_7beb8701 === 'function')) {
            _context2.next = 3;
            break;
          }
          _context2.next = 3;
          return nuxt_plugin_appplugin_7beb8701(app.context, inject);
        case 3:
          if (!(typeof nuxt_plugin_configplugin_1dbcacee === 'function')) {
            _context2.next = 4;
            break;
          }
          _context2.next = 4;
          return nuxt_plugin_configplugin_1dbcacee(app.context, inject);
        case 4:
          if (!(process.client && typeof nuxt_plugin_templatesplugind8fe56d0_c43df03e === 'function')) {
            _context2.next = 5;
            break;
          }
          _context2.next = 5;
          return nuxt_plugin_templatesplugind8fe56d0_c43df03e(app.context, inject);
        case 5:
          if (!(process.client && typeof nuxt_plugin_nuxtleaflet_4a5e0d54 === 'function')) {
            _context2.next = 6;
            break;
          }
          _context2.next = 6;
          return nuxt_plugin_nuxtleaflet_4a5e0d54(app.context, inject);
        case 6:
          if (!(typeof nuxt_plugin_tooltipplugin20b62423_644303bc === 'function')) {
            _context2.next = 7;
            break;
          }
          _context2.next = 7;
          return nuxt_plugin_tooltipplugin20b62423_644303bc(app.context, inject);
        case 7:
          if (!(typeof nuxt_plugin_buttonplugin361506c8_0fe77d26 === 'function')) {
            _context2.next = 8;
            break;
          }
          _context2.next = 8;
          return nuxt_plugin_buttonplugin361506c8_0fe77d26(app.context, inject);
        case 8:
          if (!(typeof nuxt_plugin_textareaplugin701aa164_0beff02e === 'function')) {
            _context2.next = 9;
            break;
          }
          _context2.next = 9;
          return nuxt_plugin_textareaplugin701aa164_0beff02e(app.context, inject);
        case 9:
          if (!(typeof nuxt_plugin_inputtextplugin6f231752_21dd272f === 'function')) {
            _context2.next = 10;
            break;
          }
          _context2.next = 10;
          return nuxt_plugin_inputtextplugin6f231752_21dd272f(app.context, inject);
        case 10:
          if (!(typeof nuxt_plugin_multiselectplugin4c980b95_6e732609 === 'function')) {
            _context2.next = 11;
            break;
          }
          _context2.next = 11;
          return nuxt_plugin_multiselectplugin4c980b95_6e732609(app.context, inject);
        case 11:
          if (!(typeof nuxt_plugin_configplugin149b04ac_7d087374 === 'function')) {
            _context2.next = 12;
            break;
          }
          _context2.next = 12;
          return nuxt_plugin_configplugin149b04ac_7d087374(app.context, inject);
        case 12:
          if (!(typeof nuxt_plugin_pluginutils_f63077ec === 'function')) {
            _context2.next = 13;
            break;
          }
          _context2.next = 13;
          return nuxt_plugin_pluginutils_f63077ec(app.context, inject);
        case 13:
          if (!(typeof nuxt_plugin_pluginrouting_bff11256 === 'function')) {
            _context2.next = 14;
            break;
          }
          _context2.next = 14;
          return nuxt_plugin_pluginrouting_bff11256(app.context, inject);
        case 14:
          if (!(typeof nuxt_plugin_pluginmain_6e37ecba === 'function')) {
            _context2.next = 15;
            break;
          }
          _context2.next = 15;
          return nuxt_plugin_pluginmain_6e37ecba(app.context, inject);
        case 15:
          if (!(typeof nuxt_plugin_axios_3f1c135e === 'function')) {
            _context2.next = 16;
            break;
          }
          _context2.next = 16;
          return nuxt_plugin_axios_3f1c135e(app.context, inject);
        case 16:
          if (!(typeof nuxt_plugin_capiplugin_7ce9e3bc === 'function')) {
            _context2.next = 17;
            break;
          }
          _context2.next = 17;
          return nuxt_plugin_capiplugin_7ce9e3bc(app.context, inject);
        case 17:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_58a748c7 === 'function')) {
            _context2.next = 18;
            break;
          }
          _context2.next = 18;
          return nuxt_plugin_errorpluginserver_58a748c7(app.context, inject);
        case 18:
          if (!(process.client && typeof nuxt_plugin_templatesplugin02aad04a_6b5a42b4 === 'function')) {
            _context2.next = 19;
            break;
          }
          _context2.next = 19;
          return nuxt_plugin_templatesplugin02aad04a_6b5a42b4(app.context, inject);
        case 19:
          if (!(typeof nuxt_plugin_nuxtuseragent_5e4e6fda === 'function')) {
            _context2.next = 20;
            break;
          }
          _context2.next = 20;
          return nuxt_plugin_nuxtuseragent_5e4e6fda(app.context, inject);
        case 20:
          if (!(typeof nuxt_plugin_pinia_4c9a7fd4 === 'function')) {
            _context2.next = 21;
            break;
          }
          _context2.next = 21;
          return nuxt_plugin_pinia_4c9a7fd4(app.context, inject);
        case 21:
          if (!(typeof nuxt_plugin_whitelabel_9132a414 === 'function')) {
            _context2.next = 22;
            break;
          }
          _context2.next = 22;
          return nuxt_plugin_whitelabel_9132a414(app.context, inject);
        case 22:
          if (!(typeof nuxt_plugin_validation_7d99b1b0 === 'function')) {
            _context2.next = 23;
            break;
          }
          _context2.next = 23;
          return nuxt_plugin_validation_7d99b1b0(app.context, inject);
        case 23:
          if (!(typeof nuxt_plugin_debounce_06d08b0e === 'function')) {
            _context2.next = 24;
            break;
          }
          _context2.next = 24;
          return nuxt_plugin_debounce_06d08b0e(app.context, inject);
        case 24:
          if (!(typeof nuxt_plugin_sanitizer_b82b1ab8 === 'function')) {
            _context2.next = 25;
            break;
          }
          _context2.next = 25;
          return nuxt_plugin_sanitizer_b82b1ab8(app.context, inject);
        case 25:
          if (!(typeof nuxt_plugin_jsonld_2ff76817 === 'function')) {
            _context2.next = 26;
            break;
          }
          _context2.next = 26;
          return nuxt_plugin_jsonld_2ff76817(app.context, inject);
        case 26:
          if (!(typeof nuxt_plugin_notifier_3e43155b === 'function')) {
            _context2.next = 27;
            break;
          }
          _context2.next = 27;
          return nuxt_plugin_notifier_3e43155b(app.context, inject);
        case 27:
          if (!(typeof nuxt_plugin_clickOutside_0ea087a4 === 'function')) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return nuxt_plugin_clickOutside_0ea087a4(app.context, inject);
        case 28:
          if (!(typeof nuxt_plugin_tooltip_a5fff1ec === 'function')) {
            _context2.next = 29;
            break;
          }
          _context2.next = 29;
          return nuxt_plugin_tooltip_a5fff1ec(app.context, inject);
        case 29:
          if (!(process.client && typeof nuxt_plugin_vstripe_4841e0bd === 'function')) {
            _context2.next = 30;
            break;
          }
          _context2.next = 30;
          return nuxt_plugin_vstripe_4841e0bd(app.context, inject);
        case 30:
          if (!(process.client && typeof nuxt_plugin_authPersistence_15fe8dec === 'function')) {
            _context2.next = 31;
            break;
          }
          _context2.next = 31;
          return nuxt_plugin_authPersistence_15fe8dec(app.context, inject);
        case 31:
          if (!(process.client && typeof nuxt_plugin_cropper_050a3380 === 'function')) {
            _context2.next = 32;
            break;
          }
          _context2.next = 32;
          return nuxt_plugin_cropper_050a3380(app.context, inject);
        case 32:
          if (!(process.client && typeof nuxt_plugin_iframeResizercontentWindow_4c7bfeac === 'function')) {
            _context2.next = 33;
            break;
          }
          _context2.next = 33;
          return nuxt_plugin_iframeResizercontentWindow_4c7bfeac(app.context, inject);
        case 33:
          if (!(process.client && typeof nuxt_plugin_nozoom_079c012e === 'function')) {
            _context2.next = 34;
            break;
          }
          _context2.next = 34;
          return nuxt_plugin_nozoom_079c012e(app.context, inject);
        case 34:
          if (!(process.client && typeof nuxt_plugin_matomo_ad92b6a0 === 'function')) {
            _context2.next = 35;
            break;
          }
          _context2.next = 35;
          return nuxt_plugin_matomo_ad92b6a0(app.context, inject);
        case 35:
          if (!(process.client && typeof nuxt_plugin_clarity_3440f159 === 'function')) {
            _context2.next = 36;
            break;
          }
          _context2.next = 36;
          return nuxt_plugin_clarity_3440f159(app.context, inject);
        case 36:
          if (!(process.client && typeof nuxt_plugin_sportradar_1ba2ae22 === 'function')) {
            _context2.next = 37;
            break;
          }
          _context2.next = 37;
          return nuxt_plugin_sportradar_1ba2ae22(app.context, inject);
        case 37:
          if (!(process.client && typeof nuxt_plugin_cookieConsent_826316d2 === 'function')) {
            _context2.next = 38;
            break;
          }
          _context2.next = 38;
          return nuxt_plugin_cookieConsent_826316d2(app.context, inject);
        case 38:
          if (!(process.client && typeof nuxt_plugin_vuetour_f3e3d3bc === 'function')) {
            _context2.next = 39;
            break;
          }
          _context2.next = 39;
          return nuxt_plugin_vuetour_f3e3d3bc(app.context, inject);
        case 39:
          if (!(process.client && typeof nuxt_plugin_featurebase_f807a274 === 'function')) {
            _context2.next = 40;
            break;
          }
          _context2.next = 40;
          return nuxt_plugin_featurebase_f807a274(app.context, inject);
        case 40:
          if (!(typeof nuxt_plugin_auth_9fbdb682 === 'function')) {
            _context2.next = 41;
            break;
          }
          _context2.next = 41;
          return nuxt_plugin_auth_9fbdb682(app.context, inject);
        case 41:
          if (!(typeof nuxt_plugin_axios_5659cf26 === 'function')) {
            _context2.next = 42;
            break;
          }
          _context2.next = 42;
          return nuxt_plugin_axios_5659cf26(app.context, inject);
        case 42:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 43;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 1;
                        return getRouteData(to);
                      case 1:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 43:
          return _context2.abrupt("return", {
            store: store,
            app: app,
            router: router
          });
        case 44:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };